export default "__VITE_ASSET__19af1b1f__"